import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { formatTime } from "../../utils/recipeUtils";

const RecipeDetails = ({ recipe }) => {
  const { t } = useTranslation();

  const prepTime = recipe.prepTime || 0;
  const cookTime = recipe.cookTime || 0;
  const totalTime = prepTime + cookTime;

  return (
    <Box sx={{ ml: 2, mb: 2 }}>
      <Typography variant="body2" sx={{ mb: 1 }}>
        <strong>{t("servings")}:</strong> {recipe.servings}
      </Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        <strong>{t("prepTime")}:</strong> {formatTime(prepTime, t)}
      </Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        <strong>{t("cookTime")}:</strong> {formatTime(cookTime, t)}
      </Typography>
      <Typography variant="body2">
        <strong>{t("totalTime")}:</strong> {formatTime(totalTime, t)}
      </Typography>
    </Box>
  );
};

export default RecipeDetails;
